// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__L7jK6","footer":"ModalFilter_footer__3GAEK"};